import { Alert, Button, Stack, Typography } from "@mui/material"
import { FeatureErrors } from "../common/featureErrors"
import { useRef } from "react"

/** Keep only the count while changing pages of the same collection. Giving the
 * grid zero during a request resets its controlled page. Rows always come from
 * currentData, and another filter/template must never inherit this count. */
export function useTemplateRowCount(identity: string, total?: number) {
  const count = useRef({ identity, total: total ?? 0 })
  if (count.current.identity !== identity)
    count.current = { identity, total: total ?? 0 }
  else if (total !== undefined) count.current.total = total
  return count.current.total
}

export function TemplateQueryFeedback({
  query,
  empty,
}: {
  query: { error?: unknown; isFetching: boolean; refetch: () => unknown }
  empty?: string | false
}) {
  return (
    <Stack spacing={1}>
      {query.isFetching && <Typography role="status">Загрузка…</Typography>}
      <FeatureErrors error={query.error} />
      {query.error != null && (
        <Button
          disabled={query.isFetching}
          onClick={() => void query.refetch()}
        >
          Повторить загрузку
        </Button>
      )}
      {!query.isFetching && !query.error && empty && (
        <Alert severity="info">{empty}</Alert>
      )}
    </Stack>
  )
}

export const templateDateLabel = (value: string) =>
  new Intl.DateTimeFormat("ru-RU", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: "Europe/Moscow",
  }).format(new Date(value))
